import React from 'react';
import classNames from 'classnames';

export default function Loading({active, css}) {
  return (
    <div role="loading" className={classNames(css, {
        'loader-wrapper': !css,
        'is-active': active
      })}>
      <div className="loader is-loading"></div>
    </div>
  )
}
